<div class="registered-action-display-container">
  <div>
    <mat-checkbox
      [(ngModel)]="subProject.delayed"
      (ngModelChange)="delayedChanged()"
    >
      Uitgesteld
    </mat-checkbox>
  </div>
  <div
    *ngIf="subProject.delayedRegistration != null"
    class="align-with-registration-checkbox"
  >
    <i
      >Geregistreerd door
      {{
        subProject.delayedRegistration.by?.firstName
          | personName: subProject.delayedRegistration.by?.lastName
      }}
      op
      {{
        subProject.delayedRegistration.date | formatDate: '':'dd/MM/yyyy HH:mm'
      }}</i
    >
  </div>
</div>
<textarea-input
  *ngIf="subProject.delayed || subProject.delayedReason?.length > 0"
  [placeholder]="''"
  [initContent]="subProject.delayedReason"
  (answer)="delayedReasonChanged($event)"
></textarea-input>
<div *ngIf="subProject.delayed" class="delay-handling">
  <div class="d-flex">
    <label class="select-label">Opvolgen</label>
    <mat-form-field class="select-field" appearance="outline">
      <mat-select
        matInput
        placeholder="Kies medewerker"
        [(ngModel)]="subProject.delayHandler"
        [compareWith]="compareEntities"
        (ngModelChange)="save.emit()"
      >
        <mat-option *ngFor="let option of delayHandlerOptions" [value]="option">
          {{ option.user?.firstName | personName: option.user?.lastName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="d-flex">
    <label class="select-label">Datum</label>
    <mat-form-field class="select-field" appearance="outline">
      <input
        matInput
        [matDatepicker]="handleDelayByDatePicker"
        placeholder="Selecteer een datum"
        [(ngModel)]="subProject.handleDelayByDate"
        (ngModelChange)="save.emit()"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="handleDelayByDatePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #handleDelayByDatePicker></mat-datepicker>
    </mat-form-field>
  </div>
</div>
